export function resolvePcTemplateReference(reference) {
  const normalized = String(reference ?? "").trim();
  if (!normalized) return {};
  if (/^\d+$/.test(normalized)) return { id: normalized };
  return { url: normalized, showType: "9" };
}
